import { customer } from 'src/app/queries/queries'

const fetchMe = (success = () => {}, error = () => {}) => {
  return {
    type: 'API:FETCH:CURRENT:CUSTOMER',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: customer.QUERY_CURRENT_CUSTOMER,
      variables: { expired_coupons_filter: 'expired_recently' }
    }
  }
}

const linkedService = () => ({
  type: 'API:FETCH:USER:LINKED:SERVICE',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: customer.QUERY_LINKED_SERVICE,
    variables: { type: 'wechat' }
  }
})

const didFinishedFirstCustomerPhotoIncentive = () => ({
  type: 'CUSTOMER_PHOTO_INCENTIVE:SUCCESS'
})

const fetchSalesmanInfo = () => ({
  type: 'API:FETCH:SALESMANINFO',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: { query: customer.QUERY_SALESMAN_INFO }
})

const updateCustomerRecallInfomation = (success, error) => ({
  type: 'API:UPDATE:CUSTOMER_RECALL_INFOMATION',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: customer.QUERY_CUSTOMER_RECALL_INFOMATION
  },
  success,
  error
})

const redeemRecallPackage = (success, error) => ({
  type: 'API:MUTATION:REDEEM_RECALL_PACKAGE',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: { query: customer.MUTATION_REDEEM_RECALL_PACKAGE },
  success,
  error
})

const queryRecallLandingPage = (success, error) => ({
  type: 'API:',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: { query: customer.QUERY_RECALL_LANDING_PAGE },
  success,
  error
})

export default {
  fetchMe,
  linkedService,
  fetchSalesmanInfo,
  didFinishedFirstCustomerPhotoIncentive,
  updateCustomerRecallInfomation,
  redeemRecallPackage,
  queryRecallLandingPage
}
